import MyHeaderLabel from "../components/MyHeaderLabel";
import { useMyDialog } from "../context/MyDialogProvider";
import { useLang } from "../context/TranslationProvider";

interface ConfirmDialogOptions {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
}

export function useConfirmDialog() {
  const {t} = useLang();
  const { open, close } = useMyDialog();

  const confirm = ({
    title = t("Are you sure?"),
    message = t("This action cannot be undone."),
    confirmLabel = t("Confirm"),
    cancelLabel = t("Cancel"),
    onConfirm,
  }: ConfirmDialogOptions) => {

    open({content:
      <div className="p-4 flex flex-col gap-4 
                      bg-white dark:bg-gray-800 
                      text-gray-900 dark:text-gray-100 
                      rounded-lg shadow-lg">

        <MyHeaderLabel label={title} />

        {/* Message */}
        <p className="text-gray-700 dark:text-gray-300">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex justify-end gap-2">

          {/* Cancel Button */}
          <button
            onClick={close}
            className="px-4 py-2 rounded 
                       bg-gray-200 dark:bg-gray-700 
                       text-gray-800 dark:text-gray-200
                       hover:bg-gray-300 dark:hover:bg-gray-600
                       transition"
          >
            {cancelLabel}
          </button>

          {/* Confirm Button */}
          <button
            onClick={() => {
              onConfirm();
              close();
            }}
            className="px-4 py-2 rounded 
                       bg-red-500 dark:bg-red-600 
                       text-white
                       hover:bg-red-600 dark:hover:bg-red-700
                       transition"
          >
            {confirmLabel}
          </button>

        </div>
      </div>
    });
  };

  return { confirm };
}